import { useAppSelector } from '../../store/store.hooks'

export const useUserDetails = () => {
  return useAppSelector((state) => state.auth.userDetails)
}

export const useUserFullName = () => {
  return useAppSelector((state) => state.auth.userDetails?.fullName)
}

export const useUserSitesByOrg = () => {
  return useAppSelector((state) => state.auth.sites)
}
